import { LoaderPinwheel } from "lucide-react"

import { cn } from "@/lib/utils"

interface SpinnerProps {
  className?: string
}

function Spinner({ className, ...props }: SpinnerProps) {
  return (
    <LoaderPinwheel
      aria-label="Loading"
      className={cn("animate-spin size-12 text-foreground", className)}
      role="status"
      {...props}
    />
  )
}

export { Spinner }
